var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyTicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 18C7.21995 18 5.47991 17.4722 3.99987 16.4832C2.51983 15.4943 1.36627 14.0887 0.68508 12.4441C0.00389175 10.7996 -0.174328 8.99001 0.172939 7.24418C0.520206 5.49835 1.37735 3.89472 2.63602 2.63605C3.89469 1.37737 5.49835 0.520206 7.24418 0.172939C8.99001 -0.174328 10.7996 0.00389175 12.4442 0.68508C14.0887 1.36627 15.4943 2.51983 16.4832 3.99987C17.4722 5.47991 18 7.21997 18 9C17.9978 11.3863 17.0489 13.6742 15.3616 15.3615C13.6742 17.0489 11.3863 17.9978 8.99998 18ZM8.99998 1.59698C7.5358 1.59698 6.10451 2.03116 4.88708 2.84462C3.66966 3.65807 2.72082 4.81426 2.1605 6.16698C1.60018 7.51971 1.45359 9.00822 1.73923 10.4443C2.02488 11.8803 2.72995 13.1994 3.76528 14.2347C4.80061 15.2701 6.11969 15.9751 7.55574 16.2608C8.99179 16.5464 10.4803 16.3998 11.833 15.8395C13.1857 15.2792 14.3419 14.3303 15.1554 13.1129C15.9688 11.8955 16.403 10.4642 16.403 9C16.3965 7.03861 15.6144 5.15941 14.2275 3.77248C12.8406 2.38556 10.9614 1.60351 8.99998 1.59698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27512 13.1351L3.93262 9.68527L5.07567 8.57523L7.32464 10.8902L12.8542 5.66602L13.9519 6.82557L7.27512 13.1351Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTicks);
export default __webpack_public_path__ + "static/media/grey-ticks.50483dce3000b4ee36b955b9c45ac329.svg";
export { ForwardRef as ReactComponent };